import React, { useEffect, useState } from "react";
import { MessageCircle, ArrowUp } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/data/content";

export function FloatingButtons() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" data-testid="whatsapp-fab" aria-label="WhatsApp"
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform duration-200 hover:scale-110">
        <MessageCircle className="h-7 w-7" />
      </a>
      {show && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="back-to-top" aria-label="Terug naar boven"
          className="fixed bottom-24 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-[#12151D]/80 text-white backdrop-blur transition-[transform,border-color] duration-200 hover:scale-110 hover:border-[#FF4500] hover:text-[#FF4500]">
          <ArrowUp className="h-5 w-5" />
        </button>
      )}
    </>
  );
}
